import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyD9sN2xfahq5HDNEvm2dZ-Sdi1JI-anLJg',
  authDomain: 'capino-8dfd8.firebaseapp.com',
  projectId: 'capino-8dfd8',
  storageBucket: 'capino-8dfd8.firebasestorage.app',
  messagingSenderId: '964545084628',
  appId: '1:964545084628:web:66a05fd9912f501fab4f41',
  measurementId: 'G-KFLGJ6VKS9'
}

const app = initializeApp(firebaseConfig)
const auth = getAuth(app)

export { auth }
